export const chargeFlg = {
  STOP: 0,
} as const;

export const prepaidChargeRestrictionFlg = {
  NONE: 0,
  RESTRICTED: 1,
} as const;

export const isPrepaidChargeRestrictionFlag = (
  value: unknown,
): value is typeof prepaidChargeRestrictionFlg[keyof typeof prepaidChargeRestrictionFlg] =>
  value === prepaidChargeRestrictionFlg.NONE ||
  value === prepaidChargeRestrictionFlg.RESTRICTED;

export const isPrepaidChargeRestricted = (value: unknown): boolean =>
  !isPrepaidChargeRestrictionFlag(value) ||
  value === prepaidChargeRestrictionFlg.RESTRICTED;

export const warrantyAlignmentFlg = {
  LINK_WARRANTY: 1,
};

export const processingCategory = {
  BASIC_SAVING: 1,
  REGULAR_SAVING: 2,
};
